module.exports = __webpack_public_path__ + "static/media/face_zero.c83bc566.svg";